import React from "react";
import FormHeader from "../components/FormHeader";
import background from "../assets/images/background-2.jpg";
import Footer from "../components/Footer";
const Success = ({ message, presignedUrl }) => {
  return (
    <div className="relative min-h-screen">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
        }}
      ></div>
      <div
        className="absolute inset-0 bg-black"
        style={{
          height: "100vh",
          opacity: 0.42,
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
        }}
      ></div>

      <div className="relative z-10 min-h-screen flex flex-col items-center p-2">
      <h1 className="text-3xl text-center md:text-5xl uppercase font-bold text-white mt-32 mb-6">
          Helping to Protect Hard-Earned Assets
        </h1>
        <div className="w-full md:w-1/2">
          <div className="p-11 bg-white rounded-lg shadow-lg mb-4 mt-3 w-full">
            <p className="text-center text-3xl text-bold">Thank you for participating in the BPI MS Quick Survey!</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Success;
